// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_SQ1","cls2":"CiterightPreprintReport-cls2_IU1 CiterightPreprintReport-cls1_SQ1"};